var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5176 1.35061C15.8763 1.1435 16.335 1.26641 16.5421 1.62512L18.8483 5.61958C18.9823 5.85175 18.9823 6.13782 18.8481 6.36993C18.7139 6.60203 18.4661 6.74487 18.198 6.74458L8.99046 6.73457C8.65116 6.73421 8.35437 6.50608 8.26673 6.1783C8.17909 5.85051 8.32243 5.50471 8.61628 5.33506L15.5176 1.35061ZM11.7851 5.23761L16.8989 5.24316L15.6181 3.02464L11.7851 5.23761Z",
    fill: "#1C1B1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6.75C2.86192 6.75 2.75 6.86192 2.75 7V21C2.75 21.1381 2.86192 21.25 3 21.25H21C21.1381 21.25 21.25 21.1381 21.25 21V7C21.25 6.86191 21.1381 6.75 21 6.75H3ZM1.25 7C1.25 6.03348 2.03351 5.25 3 5.25H21C21.9665 5.25 22.75 6.03349 22.75 7V21C22.75 21.9665 21.9665 22.75 21 22.75H3C2.03351 22.75 1.25 21.9665 1.25 21V7Z",
    fill: "#1C1B1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 14C14.25 12.171 15.7959 10.75 17.625 10.75H22C22.4142 10.75 22.75 11.0858 22.75 11.5V16.5C22.75 16.9142 22.4142 17.25 22 17.25H17.625C15.7959 17.25 14.25 15.829 14.25 14ZM17.625 12.25C16.5546 12.25 15.75 13.0676 15.75 14C15.75 14.9324 16.5546 15.75 17.625 15.75H21.25V12.25H17.625Z",
    fill: "#1C1B1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 7.5C22.4142 7.5 22.75 7.83579 22.75 8.25V20.25C22.75 20.6642 22.4142 21 22 21C21.5858 21 21.25 20.6642 21.25 20.25V8.25C21.25 7.83579 21.5858 7.5 22 7.5Z",
    fill: "#1C1B1E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.ef10f02c45a1b34b7176cbfacdfae380.svg";
export { ForwardRef as ReactComponent };